<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div class="lf-template-and-adhoc-container">
  <mat-expansion-panel
    [hideToggle]="!collapsible"
    [expanded]="!collapsible || !start_collapsed"
    [disabled]="!collapsible"
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false"
    class="template-adhoc-expansion-panel"
  >
    <mat-expansion-panel-header class="template-adhoc-expansion-panel">
      <mat-panel-title>
        <p title="{{ TEMPLATE | async }}" class="lf-text-label lf-ellipsis-label field-label">{{ TEMPLATE | async }}</p>
        @if (!panelOpenState && collapsible) {
          <p
            title="{{ SELECTED_TEMPLATE_NAME | async }}"
            class="lf-sub-label lf-text-body field-sub-label lf-ellipsis-label"
          >
            &nbsp;&nbsp;&nbsp;&nbsp;{{ SELECTED_TEMPLATE_NAME | async }}
          </p>
        }
      </mat-panel-title>
    </mat-expansion-panel-header>
    <lfint-field-template-container
      (fieldValuesChanged)="onFieldValuesChanged()"
      (templateSelectedChange)="onTemplateSelectedChange($event)"
    ></lfint-field-template-container>
  </mat-expansion-panel>
  <hr class="combo-container-separater" />
  <mat-expansion-panel
    [expanded]="!collapsible || !start_collapsed"
    class="template-adhoc-expansion-panel"
    [hideToggle]="!collapsible"
    [disabled]="!collapsible"
  >
    <mat-expansion-panel-header class="template-adhoc-expansion-panel">
      <mat-panel-title>
        <p title="{{ FIELDS | async }}" class="lf-text-label field-label lf-ellipsis-label">{{ FIELDS | async }}</p>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <lfint-field-adhoc-container
      (fieldValuesChanged)="onFieldValuesChanged()"
      (dialogOpened)="onDialogOpened()"
      (dialogClosed)="onDialogClosed()"
    ></lfint-field-adhoc-container>
  </mat-expansion-panel>
</div>
